module.exports = __webpack_public_path__ + "static/media/logo-header-reporting.9f306596.svg";